import "./navbar.scss";
import { Link, useLocation, useResolvedPath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import OpenSession from "parts/openSession/openSession";
import { IoIosInformationCircle } from "react-icons/io";
import { icons } from 'assets';
import React from "react";
import { logoMap } from "themes/themes";

type NavbarProps = {
    contentRef: React.RefObject<HTMLElement>;
};

type LogoProps = {
  name: keyof typeof logoMap;
};

export default function Navbar({ contentRef }: NavbarProps) {
    const { t } = useTranslation();
    const theme = useSelector((state: any) => state.theme);

    const Logo = ({ name }: LogoProps) => {
        const LogoComponent = logoMap[name];
        if (!LogoComponent) return null;

        return <LogoComponent />;
    };

    const IconLibrary = icons['library'];
    const IconApplications = icons['applications'];
    const IconDone = icons['done'];
    const IconTodo = icons['todo'];

    function CustomLink({
        to,
        activePath = [],
        label,
        classname = "",
        icon,
    }: {
        to: string;
        activePath?: string[];
        label: string;
        classname?: string;
        icon: any;
    }) {
        const location = useLocation();
        const resolvedPath = useResolvedPath(to);

        const isActive =
            activePath.length > 0
                ? activePath.some((path) => location.pathname === path)
                : location.pathname === resolvedPath.pathname;

        return (
            <li className={`${classname} ${isActive ? "active" : ""}`}>
                {to !== "" ? (
                    <Link to={to} onClick={() => contentRef.current?.focus()}>
                        <span className="iconWrapper">{icon}</span> {label}
                    </Link>
                ) : (
                    <p className="cursor-pointer">{label}</p>
                )}
            </li>
        );
    }



    return (
        <div className="navbarContainer">
            {!theme.isTabletPortraitOrMobile &&
                <>
                    <Link className="home" to="/" aria-label={`${t("go_to_home")} ${theme.name}`}>
                        <Logo name={theme.id} />
                    </Link>

                    <button
                        className="skip-link"
                        onClick={() => {
                            const el = document.getElementById("main-content");
                            if (el) el.focus();
                        }}
                    >
                        Aller au contenu principal
                    </button>
                </>
            }
            <nav>
                <ul>
                    <CustomLink
                        to="/"
                        activePath={["/", "/course"]}
                        label={t("activities_todo")}
                        icon={<IconTodo />}
                    />
                    <CustomLink
                        to="/done"
                        activePath={["/done", "/done/course"]}
                        label={t("activities_done")}
                        icon={<IconDone />}
                    />

                    {/* <CustomLink
                        to="/offline"
                        label={t("activities_offline")}
                        icon={<IoCloudOfflineOutline />}
                    /> */}

                    <CustomLink
                        to="/library"
                        label={t("title_library")}
                        icon={<IconLibrary />}
                    />

                    <CustomLink
                        to="/applications"
                        label={t("title_applications")}
                        icon={<IconApplications />}
                    />

                </ul>


            </nav>

            {!theme.isTabletPortraitOrMobile &&
                <OpenSession />
            }

        </div>
    );
}

